<div class="email-communication-container fill-height display-block">

    <ng-container *ngIf="!loading; else loadingTemplate;">
        <div class="avatar flex-centered-container">
            <img src="{{utrade_logo}}">
        </div>

        <div class="margin-top text-center policies-text">
            <div class="font-12">
                Further communication will be done using this email.
            </div>
            <div class="text-center margin-4-top font-bold font-14">
                {{currentEmail}}
            </div>
        </div>
        <div class="center-label align-items-center margin-24-top">
            <button mat-flat-button color="accent" class="ut-pro-button full-width continue-button"
                (click)="closeDialog()">
                Continue with existing mail
            </button>
        </div>

        <div class="margin-vr" *ngIf="!isOtpSent; else otpPage">
            <div class="text-center font-12 margin-32-vr policies-text">
                If you wish to change, enter new email id and verify.
            </div>
            <div class="margin-8-bottom display-flex full-width basic-form-field no-hover no-right-radius">
                <mat-form-field color="accent" appearance="outline" class="full-width">
                    <input matInput #emailRef spellcheck="false" (keydown.space)="$event.preventDefault()"
                        placeholder="Enter new email id" [formControl]="emailFormControl"
                        [errorStateMatcher]="errorMatcher">

                    <mat-error *ngIf="emailFormControl.hasError('invalidEmail')">
                        Email is not valid.
                    </mat-error>

                    <mat-error *ngIf="emailFormControl.hasError('required')">
                        This field is required.
                    </mat-error>
                </mat-form-field>
                <button mat-flat-button class="verify-button border-field font-bold margin-4-top width-30 fg-accent"
                    (click)="verifyEmail()">
                    Verify
                </button>
            </div>
            <div>

            </div>
        </div>

        <ng-template #otpPage>
            <div class="margin-vr">
                <div class="font-12 margin-bottom policies-text">
                    We've just sent you a 6 digits code to your email
                    <div class="margin-4-top">
                        ({{maskEmail()}}).
                        <span class="fg-accent font-bold font-12 cursor-pointer" (click)="changeEmail()">Change
                            email</span>
                    </div>
                </div>

                <div>
                    <app-otp-input (checkOtp)="verifyOTP()" [applyInitialFocus]="isOtpSent"
                        #emailOtpInput></app-otp-input>
                </div>

                <div class="font-12">
                    Didn't receive the code?
                    <span class="fg-accent font-bold font-12" type="button" (click)="resendOTP()"
                        [ngClass]="{'cursor-pointer-outline' : timerEnabled}">
                        Resend OTP<span class="counter" *ngIf="!timerEnabled"> in {{ displayTimer }}
                        </span>
                    </span>
                </div>
            </div>
        </ng-template>
    </ng-container>

</div>

<ng-template #loadingTemplate>
    <div class="fill-height center-label">
        <div class="text-center ">
            <h3>Please wait...</h3>
        </div>
        <div class="flex-centered-container">
            <mat-spinner class="spinner"></mat-spinner>
        </div>
    </div>
</ng-template>